import { SET_STORE_REQUESTS_LIST } from './actionType'

export function setStoreRequestsList(storeRequests) {
  return {
    type: SET_STORE_REQUESTS_LIST,
    storeRequests: storeRequests,
  }
}
